/* eslint-disable prefer-promise-reject-errors */
export function mockRequest(abortSignal, executor) {
  if (abortSignal.aborted) {
    console.log('already aborted');
    return Promise.reject(true);
  }
  return new Promise((resolve, reject) => {
    abortSignal.onabort = () => {
      console.log('on abort');
      reject(true);
    };
    setTimeout(() => {
      console.log('mock request');
      executor(resolve, reject);
    }, 5000);
  });
}
